'use strict';

const BaseModel = require('../base/BaseModel');
const { getScrollableItemWidth, setWidthStyle } = require('../utils');

/**
 * View-model for carousels that are scrolled through horizontally.
 * @class
 */
class ScrollModel extends BaseModel {
    constructor({ itemsPerPage } = {}) {
        // There's no state to update so no need to pass the `onStateChange` callback.
        super();

        Object.assign(this, {
            // The width of each item.
            _width: getScrollableItemWidth(itemsPerPage, 1, 3),
        });
    }

    /**
     * Implement the `transformItemStyle` method from the `BaseModel`.
     * @param  {Object} style
     */
    transformItemStyle(style) {
        setWidthStyle(style, this._width);
    }
}

module.exports = ScrollModel;



// WEBPACK FOOTER //
// ./assets/js/global/components/carousel/models/ScrollModel.es.js